import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { layoutDirection } from 'utils/layout/rtl';
import { jssPreset, StylesProvider, ThemeProvider } from '@material-ui/styles';
import { createTheme, theme as defaultTheme } from 'assets/jss/material-dashboard-pro-react';
import { create, Plugin } from 'jss';
import rtl from 'jss-rtl';

interface IRTLProps {
	children: React.ReactElement | React.ReactElement[];
	theme?: object;
}

const RTL = ({ children, theme = defaultTheme }: IRTLProps) => {
	const language = useSelector((state: types.redux.rootReducer) => state.settings.language);
	const dir = layoutDirection(language);
	const jss = create({
		plugins: [...jssPreset().plugins, dir === 'rtl' ? rtl() : ({} as Plugin)],
	});

	return (
		<StylesProvider jss={jss}>
			<ThemeProvider theme={createTheme(dir, language, theme)}>{children}</ThemeProvider>
		</StylesProvider>
	);
};

RTL.propTypes = {
	children: PropTypes.node,
	theme: PropTypes.object,
};

export default RTL;
